import { Column, Entity, PrimaryGeneratedColumn, OneToMany } from "typeorm"
import { OnboardingState } from "../../enumerations";
import { PendingUser, TariffData, Address, PhoneNumber } from "../../interfaces";


@Entity()
export class OnBoarding {

  @PrimaryGeneratedColumn({ name:"id" })
  id?: number;
  
  @Column({nullable : false})
  state!: OnboardingState

  @Column({nullable : false})
  client_name!: string

  @Column({nullable : false})
  client_xero_name!: string

  @Column({nullable : false})
  primary_contact_email!: string

  @Column({nullable : true})
  accounting_contact_email!: string

  @Column({nullable : false})
  unique_reference!: string

  @Column({ type: 'json', nullable : true }) 
  users!: PendingUser[]

  @Column({ type: 'json', nullable : false})
  desired_tariffs!: TariffData[] 

  @Column('datetime')
	creation_date!: Date;

  /* XERO CONTACT DETAILS */

  @Column({nullable : true, default:''})
  xero_primary_contact_firstname!: string

  @Column({nullable : true, default:''})
  xero_primary_contact_lastname!: string

  @Column({nullable : true, default:''})
  xero_company_registration!: string

  @Column({nullable : true, default:''})
  xero_company_taxnumber!: string

  @Column({ type: 'json', nullable : true }) 
  xero_street_address!: Address

  @Column({ type: 'json', nullable : true }) 
  xero_phone_numbers!: PhoneNumber[]
  
}